import React, { useContext, createContext } from 'react'
import { useDispatch } from 'react-redux'

import { APP_SET_LOADING } from '../constants/action-types'

const reduxContext = createContext()

export function ReduxProvider({ children }) {
  const actions = useReduxActions()
  return (
    <reduxContext.Provider value={actions}>
      {children}
    </reduxContext.Provider>
  )
}

export function useRedux() {
  return useContext(reduxContext)
}

function useReduxActions() {
  const dispatch = useDispatch()

  const setAppLoading = payload => {
    return dispatch({ type: APP_SET_LOADING, payload })
  }

  return {
    setAppLoading,
  }
}